import { Link } from 'react-router-dom';
import { Sun } from 'lucide-react';
import { RegisterForm } from '../components/Auth/RegisterForm.jsx';

export const RegisterPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Sun className="w-12 h-12 text-solar-500" />
          <span className="text-3xl font-bold text-gray-900">سولار پلتفرم</span>
        </Link>
      </div>

      <RegisterForm />

      <p className="mt-8 text-center text-sm text-gray-600">
        با ثبت‌نام،{' '}
        <Link to="/terms" className="text-primary-600 hover:text-primary-500">
          قوانین و مقررات
        </Link>{' '}
        را می‌پذیرم
      </p>
    </div>
  );
};